import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { EvidenceSlotState } from '@services/evidenceSlot';

interface EvidenceCaptureLaneProps {
  captures: EvidenceSlotState['captures'];
  onOpenLightbox: (documentId: string) => void;
}

/**
 * Sprint 11, story-042 (U77). Horizontal lane for the repeatable PROGRESS_PHOTO slot — a lane of
 * thumbnails, not a single filled/empty cell, per docs/ux/story-042-design.md.
 */
export const EvidenceCaptureLane: React.FC<EvidenceCaptureLaneProps> = ({ captures, onOpenLightbox }) => {
  if (captures.length === 0) {
    return <p className="text-sm text-frozenGrayShades6 dark:text-frozenGrayShades4">No progress photos yet.</p>;
  }

  return (
    <div className="flex gap-2 overflow-x-auto pb-1" data-testid="evidence-capture-lane">
      {captures.map((c) => (
        <button
          key={c.documentId}
          type="button"
          onClick={() => onOpenLightbox(c.documentId)}
          className="relative flex-shrink-0 w-20 h-20 rounded-md overflow-hidden border border-frozenGrayShades2 dark:border-frozenGrayShades8">
          {c.thumbnailUrl ? (
            <img src={c.thumbnailUrl} alt="Progress capture" className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-amber-50 dark:bg-amber-900/20">
              <AlertTriangle size={16} className="text-amber-600" />
            </div>
          )}
          {c.deliveryStatus === 'FAILED' && (
            <span className="absolute inset-x-0 bottom-0 bg-amber-600 text-white text-[10px] text-center">
              FAILED
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default EvidenceCaptureLane;
